import { Seo } from "../components/Seo";
import { Eyebrow } from "../components/Blocks";
import { siteConfig } from "../config/site";

export default function Privacy() {
  const { phone, email } = siteConfig.contact;

  return <main>
    <Seo title="개인정보처리방침" path="/privacy" description="마이리틀클래식 개인정보처리방침" />
    <section className="legal">
      <Eyebrow>PRIVACY</Eyebrow>
      <h1>개인정보처리방침</h1>
      <p>마이리틀클래식은 공연 및 단체관람 문의에 답변하기 위해 필요한 범위에서 개인정보를 처리하며, 광고·홍보 목적으로 사용하지 않습니다.</p>

      <article className="privacy-content">
        <section>
          <h2>1. 처리 목적과 항목</h2>
          <p>공연 섭외·단체관람 문의 확인, 상담, 일정 조율 및 견적 안내를 위해 다음 정보를 처리합니다.</p>
          <ul>
            <li><b>필수</b> 기관명, 담당자명, 연락처</li>
            <li><b>공연 섭외 문의 시</b> 견적서를 받을 이메일</li>
            <li><b>선택</b> 희망 일정, 지역, 예상 인원, 공연 횟수, 행사 예산, 기타 요청사항</li>
          </ul>
        </section>

        <section>
          <h2>2. 보유 및 이용 기간</h2>
          <p>문의 정보는 상담 종료일로부터 1년간 보관한 뒤 지체 없이 파기합니다. 다만 관계 법령에 따라 보존할 의무가 있는 경우에는 해당 기간 동안 보관합니다.</p>
        </section>

        <section>
          <h2>3. 제3자 제공 및 처리 위탁</h2>
          <p>마이리틀클래식은 문의 정보를 제3자에게 판매하거나 광고 목적으로 제공하지 않습니다. 문의 접수·보관과 알림을 위해 Google의 Apps Script, Sheets 및 Gmail 서비스를 이용하며, 웹사이트 제공과 보안을 위해 Cloudflare의 호스팅 서비스를 이용합니다. 각 서비스의 처리에는 해당 사업자의 개인정보 보호정책이 적용될 수 있습니다.</p>
        </section>

        <section>
          <h2>4. 파기 방법</h2>
          <p>보유 기간이 지난 문의 기록은 Google Sheets와 이메일에서 삭제하며, 전자적 파일은 복구하기 어려운 방법으로 파기합니다.</p>
        </section>

        <section>
          <h2>5. 정보주체의 권리</h2>
          <p>문의자는 본인의 개인정보에 대해 열람, 정정, 삭제 또는 처리 정지를 요청할 수 있습니다. 아래 연락처로 요청하면 본인 확인 후 지체 없이 처리합니다.</p>
        </section>

        <section>
          <h2>6. 자동 수집 정보</h2>
          <p>마이리틀클래식은 맞춤형 광고를 위한 쿠키를 직접 사용하지 않습니다. 다만 사이트의 안정적인 제공과 보안을 위해 호스팅 과정에서 접속기록 등 최소한의 기술 정보가 처리될 수 있습니다.</p>
        </section>

        <section>
          <h2>7. 개인정보 보호 문의</h2>
          <p>개인정보 보호 업무 및 관련 요청은 마이리틀클래식에서 담당합니다.</p>
          <p>전화 {phone}<br />이메일 {email}</p>
        </section>

        <section>
          <h2>8. 방침의 변경</h2>
          <p>이 방침은 2026년 8월 29일부터 적용됩니다. 내용이 변경되는 경우 이 페이지를 통해 안내합니다.</p>
        </section>
      </article>
    </section>
  </main>;
}
